window.addEventListener("breeze-initiate-checkout", event => {
    const eventData = event.detail;
    breezeInitiateCheckout(eventData)
}
);
function breezeInitiateCheckout(payload) {
    try {
        merchantInitiateCheckoutCustomCode(payload.data)
    } catch (e) {
        console.log("Error in triggering merchants initiate checkout script : ", e)
    }
}
function merchantInitiateCheckoutCustomCode(params) {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments)
    }
    gtag("js", new Date),
    gtag("config", "AW-17533854849"),
    window.gtag("event", "begin_checkout", {
        send_to: ["AW-17533854849/6_bjCLaA8ZQbEIHJ5ahB", "G-H6Q8W1K9W8"],
        value: params.totalPrice,
        currency: "INR",
        transaction_id: params.shopOrderId
    })
}
window.addEventListener("breeze-add-payment-info", event => {
    const eventData = event.detail;
    breezeAddPaymentInfo(eventData)
}
);
function breezeAddPaymentInfo(payload) {
    try {
        merchantAddPaymentInfoCustomCode(payload.data)
    } catch (e) {
        console.log("Error in triggering merchants add Payment info script : ", e)
    }
}
function merchantAddPaymentInfoCustomCode(params) {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments)
    }
    gtag("js", new Date),
    gtag("config", "AW-17533854849"),
    window.gtag("event", "add_payment_info", {
        send_to: ["AW-17533854849/gUP6CO-D8ZQbEIHJ5ahB", "G-H6Q8W1K9W8"],
        value: params.totalPrice,
        currency: "INR",
        transaction_id: params.shopOrderId
    })
}
window.addEventListener("breeze-purchase", event => {
    const eventData = event.detail;
    breezePurchase(eventData)
}
);
function breezePurchase(payload) {
    try {
        merchantPurchaseCustomCode(payload.data)
    } catch (e) {
        console.log("Error in triggering merchants purchase script : ", e)
    }
}
function merchantPurchaseCustomCode(params) {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments)
    }
    console.log("purchase params", params),
    gtag("js", new Date),
    gtag("config", "AW-17533854849"),
    window.gtag("event", "purchase", {
        send_to: ["AW-17533854849/RSeSCJHG6ZQbEIHJ5ahB", "G-H6Q8W1K9W8"],
        value: params.totalPrice,
        currency: "INR",
        transaction_id: params.shopOrderId,
        items: params.items
    })
}

